import { forwardRef, useImperativeHandle, useRef } from 'react';
import { FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useReactToPrint } from 'react-to-print';

import Button from 'components/field/Button';
import * as S from 'components/form/FormLayout.styled';
import Image from 'components/global/Image';

import { faPrint } from '@fortawesome/pro-solid-svg-icons';

const Form = forwardRef((props, ref) => {
	const { children, viewPrintButton, borderless, formMethods = {}, onPrint, className, ...rest } = props;
	const { t } = useTranslation();

	const contentRef = useRef(null);
	useImperativeHandle(ref, () => contentRef.current);
	const handlePrint = useReactToPrint({ contentRef });

	return (
		<>
			<FormProvider {...formMethods}>
				<S.Form
					ref={contentRef}
					method="dialog"
					className={`${borderless ? 'borderless' : ''} ${className ?? ''}`}
					autoComplete="off"
					{...rest}>
					{children}
					{viewPrintButton && !onPrint && (
						<S.PoweredByOTO>
							{t('poweredBy')}{' '}
							<Image
								url={'https://storage.googleapis.com/tryoto-public/public/assets/images/otoLogo.png'}
								alt="logo"
							/>
						</S.PoweredByOTO>
					)}
				</S.Form>
			</FormProvider>

			{viewPrintButton && (
				<S.FormModalFooter>
					<Button icon={faPrint} variant="outline" label="print" onClick={onPrint ? onPrint : handlePrint} />
				</S.FormModalFooter>
			)}
		</>
	);
});

Form.displayName = 'Form';

export default Form;
